import React, { useEffect, useMemo, useState } from "react";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import NavTime from "./components/NavTime";
import OpeningHG from "./components/OpeningHG";
import OpeningH from "./components/OpeningH";
import WorkingHG from "./components/WorkingHG";
import WorkingH from "./components/WorkingH";
import baseUrl from "../../../../api/baseUrl";
import TabBar from "../../../../components/tabbar/TabBar";

const weekArray = [
  { week: "Monday", abbreviation: "Mon" },
  { week: "Tuesday", abbreviation: "Tue" },
  { week: "Wednesday", abbreviation: "Wed" },
  { week: "Thursday", abbreviation: "Thu" },
  { week: "Friday", abbreviation: "Fri" },
  { week: "Saturday", abbreviation: "Sat" },
  { week: "Sunday", abbreviation: "Sun" },
];

const formatTime = (date: Date): string => {
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const generateTimeSlots = (
  formData: { from: string; to: string; timeDuration: string },
  formatTime: (date: Date) => string
) => {
  const startTime = new Date(`01/01/2000 ${formData.from}`);
  const endTime = new Date(`01/01/2000 ${formData.to}`);
  const duration = parseInt(formData.timeDuration, 10);

  const timeSlotsArray: {
    formattedTime: string;
    startTime: string;
    endTime: string;
    interval: number;
  }[] = [];
  let currentTime = startTime;

  while (currentTime <= endTime) {
    const formattedTime = formatTime(currentTime);
    const formattedStartTime = formatTime(currentTime);

    const endTimeSlot = new Date(currentTime);
    endTimeSlot.setMinutes(endTimeSlot.getMinutes() + duration);
    const formattedEndTime = formatTime(endTimeSlot);

    timeSlotsArray.push({
      formattedTime,
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      interval: duration,
    });

    currentTime.setMinutes(currentTime.getMinutes() + duration);
  }

  return timeSlotsArray;
};

function Managetime() {
  const [formData, setformData] = useState({
    from: "09:00",
    to: "17:00",
    timeDuration: "30",
  });

  const [doctorId, setdoctorId] = useState("");
  const [dentists, setdentists] = useState([]);

  useEffect(() => {
    baseUrl
      .get("/appointment/findAllAppointmentDentist")
      .then((response) => {
        setdentists(response.data.data);
        setdoctorId(response.data.data[0]._id);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const timeArray = useMemo(
    () => generateTimeSlots(formData, formatTime),
    [formData]
  );

  return (
    <div className="mt-2 sm:mt-4 space-y-3 sm:space-y-6 px-2 sm:px-0">
      <NavTime setformData={setformData} formData={formData} />
      <OpeningHG timeData={timeArray} weekArray={weekArray} />
      <OpeningH timeData={timeArray} />
      <WorkingHG
        timeData={timeArray}
        doctorId={doctorId}
        setdoctorId={setdoctorId}
        dentists={dentists}
        weekArray={weekArray}
      />
      <WorkingH
        timeData={timeArray}
        doctorId={doctorId}
        setdoctorId={setdoctorId}
        dentists={dentists}
      />
    </div>
  );
}

export default Managetime;
